export default "__VITE_ASSET__BjUeOazx__"